import type { Template } from '../score';
import { houseScore } from './house';
import type { HouseVariant } from './house';

const CLOCK: HouseVariant = {
  swing: 50,
  lufs: -11,
  mix: (bpm) => ({ reverbDecay: 2.1, delayTime: (60 / bpm) * 0.75, delayFeedback: 0.26, drive: 1.4, softness: 1.25, masterLowpass: 13000, pumpDepth: 0.32, pumpRelease: 0.24 }),
  closedHats: ['x...x...x...x...', 'x...x...x...x.o.'],
  openHats: ['..X...X...X...X.', '..X...X...X.x.X.'],
  rims: ['...x......x..x..', '...x..x....x..x.', '......x..x....x.'],
  shakers: ['-o-o-o-o-o-o-o-o', '-o-o-o-oxo-o-o-o'],
  stabs: ['X..x..x...x..x..', 'X.....x...x..x..', 'x..x..x...x...x.'],
  introStabs: ['...x......x.....', '......x.......x.'],
  breakSub: 'X...x...X...x...',
};

export const RELOJOARIA: Template = {
  id: 'relojoaria',
  genre: 'clockwork house',
  bpm: [110, 132],
  ref: { seed: 'engrenagem', title: 'Engrenagem', params: { bpm: 120, bars: 28, energy: 0.55 } },
  score: (seed, p) => houseScore(RELOJOARIA, CLOCK, seed, p),
};
